export const title = 'Vendas de campanhas';
import CampaignAttributionDateNote from '../../shared/partials/campaign-attribution-date-note.pt.mdx';

Quantidade de vendas atribuídas a campanhas no período selecionado.

<CampaignAttributionDateNote />
